import { StatPill } from "@/components/teacher/StatPill";
import { TeacherPage } from "@/components/teacher/TeacherPage";
import { MyClassroomsDocument } from "@/generated/graphql";
import { format, useT } from "@/i18n";
import { useQuery } from "@apollo/client/react";
import { useNavigate } from "@tanstack/react-router";
import { HiAcademicCap, HiBookOpen } from "react-icons/hi";
import { useAuth } from "../../contexts/AuthContext";

export function TeacherHomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data } = useQuery(MyClassroomsDocument);
  const t = useT();

  const classroomCount = data?.myClassrooms.length;

  return (
    <TeacherPage title={format(t["home.welcome"], { name: user?.name ?? "" })}>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => navigate({ to: "/teacher/books" })}
          className="app-card app-card-link flex h-56 flex-col justify-between p-6 text-left"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-app-sky">
            <HiBookOpen className="h-6 w-6 text-app-ink" />
          </span>
          <span>
            <span className="app-title block">{t["home.books"]}</span>
            <span className="body-sm mt-1 block text-app-muted">{t["home.books.caption"]}</span>
          </span>
        </button>

        <button
          type="button"
          onClick={() => navigate({ to: "/teacher/classrooms" })}
          className="app-card app-card-link flex h-56 flex-col justify-between p-6 text-left"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-app-aqua/15">
            <HiAcademicCap className="h-6 w-6 text-app-ink" />
          </span>
          <span>
            <span className="flex items-center gap-2">
              <span className="app-title">{t["home.classrooms"]}</span>
              {classroomCount !== undefined && <StatPill>{classroomCount}</StatPill>}
            </span>
            <span className="body-sm mt-1 block text-app-muted">
              {t["home.classrooms.caption"]}
            </span>
          </span>
        </button>
      </div>
    </TeacherPage>
  );
}
